<template>
  <div>
    <ul class="menu">
      <li 
        class="menu-item" 
        v-for="(item, index) in data" 
        :key="index" 
        :class="{'active': currentMenuId === item.id}"
        @click="menuClick(item, index)" 
        @mouseenter="showSubMenu(index)" 
        @mouseleave="hideSubMenu(index)"
      >
        <span>{{ item.name }}</span>
        <img 
          class="m-l-5" 
          v-show="item.children && item.children.length > 0" 
          src="../../assets/img/header/arrow.png"
        >
        <div 
          v-if="item.children && item.children.length > 0" 
          class="nav-item-container" 
          :class="{'visible': visibleSubMenus[index]}"
        >
          <nav-item 
            v-for="(citem, cindex) in item.children" 
            :key="cindex" 
            :data="citem" 
            :layer="1" 
            :index="getGlobalIndex(index, cindex)"
            :parentData="item"
            @pageSkip="pageSkip(item.id, item.path)"
          ></nav-item>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import NavItem from "./NavItem";

export default {
  name: "NavMenu",
  components: { NavItem: NavItem },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      parentId: 0,
      currentMenuIndex: 0,
      currentMenuId: -1,
      globalIndices: [],
      visibleSubMenus: {}
    }
  },
  created: function() {
    this.calculateGlobalIndices()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    menuClick: function(route, index) {
      this.currentMenuIndex = index
      if (route.path) {
        if (this.$router.currentRoute.path !== route.path) {
          if (route.path.indexOf("http") !== -1) {
            window.open(route.path, "_blank")
          } else {
            this.$router.push({ path: route.path })
            this.currentMenuId = route.id
            this.saveState(route.path)
          }
        }
      }
    },
    pageSkip: function(id, path) {
      this.currentMenuId = id
      this.saveState(path)
    },
    saveState: function(id) {
      this.$store.commit('updateCurrentPath', id)
    },
    getMenuIdByPath: function(data, path) {
      var self = this
      if (!data) {
        return -1
      }
      for (var i = 0; i < data.length; i++) {
        var route = data[i]
        if (route.path === path) {
          return route.id
        }
        if (route.children && self.isChildPath(route.children, path)) {
          return route.id
        }
      }
      return -1
    },
    isChildPath: function(children, path) {
      var self = this
      return children.some(function(route) {
        if (route.path === path) {
          return true
        }
        return route.children && self.isChildPath(route.children, path)
      })
    },
    calculateGlobalIndices: function() {
      var globalIndex = 0
      this.globalIndices = []
      for (var i = 0; i < this.data.length; i++) {
        var item = this.data[i]
        if (item.children && item.children.length > 0) {
          var indices = []
          for (var j = 0; j < item.children.length; j++) {
            indices.push(globalIndex)
            globalIndex++
          }
          this.globalIndices.push(indices)
        } else {
          this.globalIndices.push([])
        }
      }
    },
    getGlobalIndex: function(parentIndex, childIndex) {
      return this.globalIndices[parentIndex][childIndex]
    },
    showSubMenu: function(index) {
      this.$set(this.visibleSubMenus, index, true)
    },
    hideSubMenu: function(index) {
      this.$set(this.visibleSubMenus, index, false)
    },
    handleScroll: function() {
      for (var key in this.visibleSubMenus) {
        this.$set(this.visibleSubMenus, key, false)
      }
    }
  },
  watch: {
    data: {
      handler: function() {
        this.calculateGlobalIndices()
        this.currentMenuId = this.getMenuIdByPath(this.data, this.$store.state.currentPath)
      },
      deep: true
    }
  }
}
</script>

<style>
.menu-item {
  position: relative;
}

.pc-box .menu-item .nav-item-container {
  display: flex;
  flex-wrap: wrap;
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  height: auto;
  background: #fff;
  min-height: 200px;
  visibility: hidden;
  opacity: 0;
  transition: opacity .3s ease, visibility .3s ease;
}

.pc-box .menu {
  cursor: pointer;
  text-align: center;
}

.pc-box .menu-item {
  font-size: 16px;
  color: white;
  display: inline-block;
  margin-left: 16px;
  letter-spacing: 1px;
  padding: 10px 22px;
}

.pc-box .menu-item:hover > span {
}

.pc-box .menu-item > img {
  margin: auto 0;
  display: inline-block;
  position: absolute;
  transform: translate(-50%, -50%);
  right: 0px;
  top: 50%;
  width: 12px;
  height: 12px;
}

.pc-box .menu-item .nav-item-container.visible {
  opacity: 1;
  visibility: visible;
  transition: opacity .3s ease, visibility .3s ease;
  width: 100%;
}

.pc-box .nav-item-container {
  padding: 40px 0;
  color: rgba(0, 0, 0, .5);
  font-size: 15px;
  text-align: center;
  width: 100%;
}

.pc-box .active {
  background: url("../../assets/img/header/under_line.png");
  background-repeat: no-repeat;
  background-position: center 40px;
}

.pc-box .menu .menu-item:hover {
  background-image: url("../../assets/img/header/under_line.png");
  background-repeat: no-repeat;
  background-position: center 40px;
}

.pc-box .menu .menu-item:hover > img {
  transform: rotate(-180deg);
  transform-origin: 3px 3px;
  transition: transform .3s ease;
  opacity: 1;
  display: inline-block;
}

.rotate180 {
  transform: rotate(-180deg);
  transition: transform .3s ease;
  opacity: 1;
  display: block;
}

.m-l-5 {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenu/NavMenu.vue